import store from 'dashboard/store';
import PatientOverviewKnowledge from 'dashboard/templates/views/Patient/Knowledge/PatientOverviewKnowledge';

import progress from './progress';
import timeline from './timeline';
import selection from './selection';

/**
 * Knowledge routes
 * @name router.Knowledge
 */

const navigationSteps = {
  prevDiscussionStep: {
    PatientRecordKnowledgeProgress: 'PatientRecordProgress',
    PatientRecordKnowledgeTimeline: 'PatientRecordKnowledgeProgress',
    PatientRecordKnowledgeSelection: 'PatientRecordKnowledgeTimeline',
  },
  nextDiscussionStep: {
    PatientRecordKnowledgeProgress: 'PatientRecordKnowledgeTimeline',
    PatientRecordKnowledgeTimeline: 'PatientRecordKnowledgeSelection',
    PatientRecordKnowledgeSelection: 'PatientRecordProgress',
  }
}

export default {
  path: 'knowledge',
  component: PatientOverviewKnowledge,
  name: 'PatientRecordKnowledge',
  props: () => {
    const beforeFirstSDM = store.getters['patientSummary/currentVersion'] < 3;
    return !beforeFirstSDM
      ? navigationSteps
      : {
        nextDiscussionStep: navigationSteps.nextDiscussionStep,
        prevDiscussionStep: {
          ...navigationSteps.prevDiscussionStep,
          PatientRecordKnowledgeSelection: 'PatientRecordProgress'
        }
      }
  },
  redirect: () => {
    const beforeFirstSDM = store.getters['patientSummary/currentVersion'] < 3
    return {
      name: beforeFirstSDM
      ? 'PatientRecordKnowledgeSelection'
      : 'PatientRecordKnowledgeProgress'
    }
  },
  meta: {
    // title: 'Patient Record Knowledge',
    title: t => `${t('patient.patientRecord')} - ${t('nutritionBarriers.knowledgeAnswer', 'questionnaires')}`,
    loggedInOnly: true,
  },
  children: [
    progress,
    timeline,
    selection,
  ],
};
